import type { ReleaseNotesContent } from './release.notes.types';
import content from './release.notes.content.json';

export const RELEASE_NOTES_CONTENT: ReleaseNotesContent = content;
